<template>
  <div>
    <v-list class="places-list-container" two-line v-if="hasPlaces" dense>
      <PlacesListItem
        v-for="place in places"
        :place="place"
        :key="place.uniqueId"
        :isMapped="place.mapped"
        @change="placeOnChange"
      ></PlacesListItem>
    </v-list>
    <v-list text-align-center v-if="!hasPlaces">
      <p class="text-center">
        No Places Found. If you would like to add your own places please contact
        us.
      </p>
    </v-list>
  </div>
</template>

<script>
const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "PlacesList",
  components: {
    PlacesListItem: () => import("@/components/places/PlacesListItem"),
  },
  props: {
    places: {
      type: Array,
    },
  },
  computed: {
    hasPlaces() {
      if (this.places && this.places.length > 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    placeOnChange(input) {
      this.$emit(EMITTED_ACTIONS.CHANGE, input);
    },
  },
};
</script>

<style scoped>
.theme--light.v-list {
  background: #f7f7fa !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
.places-list-container {
  height: 85vh !important;
  overflow-y: auto !important;
}
::-webkit-scrollbar {
  width: 8px;
  height: 3px;
}
::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #c8c8c8;
  border-radius: 3px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(204, 204, 204, 1);
  border-radius: 3px;
}
</style>
